"use client";

import * as React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const metrics = [{
  value: "5+",
  label: "Anos de Experiência"
}, {
  value: "500+",
  label: "Mulheres Viajantes"
}, {
  value: "100%",
  label: "Suporte Local"
}, {
  value: "24/7",
  label: "Atendimento VIP"
}];
export default function ImpactInNumbers() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="141277" id="nossa-expertise" className="w-full bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4">
        <div ref={ref} className={cn("grid grid-cols-1 md:grid-cols-4 gap-16 md:gap-0 items-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          {metrics.map((metric, i) => <div key={i} data-index={i} className="relative flex flex-col items-center justify-center text-center space-y-3 py-4">
              <span className="text-6xl font-bold font-default tracking-tight !text-[rgba(27,164,172,1)] md:text-[4rem]">
                {metric.value}
              </span>
              <span className="text-base font-serif text-muted-foreground tracking-normal">
                {metric.label}
              </span>

              {i < metrics.length - 1 && <>
                  {}
                  <Separator orientation="vertical" className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 h-1/2 bg-border/40" />
                  {}
                  <Separator orientation="horizontal" className="md:hidden absolute -bottom-8 left-1/2 -translate-x-1/2 w-1/2 bg-border/40" />
                </>}
            </div>)}
        </div>
      </div>
    </section>;
}